import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const AmsterdamIcon = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M0.5 20V10H1.5V9H2.5V8L3.5 5L4.5 8V9H5.5V10H6.5V20H0.5Z",
                fill: "#E87722"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7.5 20V7L10 2L12.5 7V20H7.5Z",
                fill: "#E87722"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M13.5 20V8H14.5V6L16.5 3L18.5 6V8H19.5V20H13.5Z",
                fill: "#E87722"
            })
        ]
    });
